
import React, {useState} from 'react'
import { useTranslation } from 'react-i18next'
import {Button, Card, CardBody, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table} from 'reactstrap'

import SiteService from '../../services/SiteService'

const Damages = ({ vehicleInspectionDamages }) =>
{
    const { t } = useTranslation()
    const [selectedPicPath, setSelectedPicPath] = useState('')

    const handleSmallInspectionPicClicked = (imagePath) =>
    {
        setSelectedPicPath(imagePath)
    }

    const handleLargeInspectionPicClicked = () =>
    {
        setSelectedPicPath('')
    }

    return (
        <>
            <Row>
                <Col md="12">
                    <div className="table-responsive" >
                        <Table className="align-items-center table-flush">
                            <thead className="thead-light">
                            <tr>
                                <th className="sort" scope="col">{ t('Auctions.Damages.DamageArea') }</th>
                                <th className="sort" scope="col">{ t('Auctions.Damages.DamageType') }</th>
                                <th className="sort" scope="col">{ t('Auctions.Damages.EstimatedRepair') }</th>
                                <th className="sort" scope="col">{ t('Auctions.Damages.Pictures') }</th>
                            </tr>
                            </thead>
                            <tbody className="list">
                            {vehicleInspectionDamages.map((damage) => (
                                <tr key={ damage.vehicleInspectionDamageId } style={{ cursor: 'pointer' }} >
                                    <td>{ damage.damageArea }</td>
                                    <td>{ damage.damageType }</td>
                                    <td>{ SiteService.priceDisplay(damage.estimatedRepairCost) }</td>
                                    <td>
                                        <div style={{ display: 'inline-block' }}>
                                            {damage.damageImages.map((damageImage) => (
                                                <div key={ damageImage.vehicleInspectionPictureId } className="inspection-pic" style={{ display:'inline', paddingLeft: '10px' }}>
                                                    <img
                                                        className="inspection-pic-sm"
                                                        src={ damageImage.imagePath }
                                                        width="100px"
                                                        height="100px" alt="..."
                                                        onClick={ () => { handleSmallInspectionPicClicked(damageImage.imagePath) } }
                                                        style={{ cursor: 'pointer' }}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </Row>

			<Modal
				size="lg"
				isOpen={ selectedPicPath.length > 0 }
				toggle={ () => handleLargeInspectionPicClicked() }
			>
				<ModalHeader toggle={ () => handleLargeInspectionPicClicked() } charCode="Y"></ModalHeader>
				<ModalBody>
					<Card className="border-0 mb-0">
						<CardBody>
							<div className="text-center">
								<img className="inspection-pic-lg" src={selectedPicPath} width="700px" height="600px" alt="..."/>
							</div>
							<div className="text-center">
								<Button
									className="my-4"
									color="primary"
									type="button"
									onClick={() => handleLargeInspectionPicClicked()}
								>
									Close
								</Button>
							</div>
						</CardBody>
					</Card>
				</ModalBody>
				<ModalFooter></ModalFooter>
			</Modal>
        </>
    )
}

export default Damages
